import type { TourStep } from 'BreetHelpers';

export interface ITourStepConfig {
	selector: string;
	title: string;
	description: string;
	ctaLabel: string;
	ctaPath?: string;
	nextStep?: TourStep;
	placement: 'bottom' | 'right';
	step?: number;
	steps?: number;
}

export const tourSteps: Record<TourStep, ITourStepConfig> = {
	sandbox: {
		selector: "[data-tour='sandbox']",
		title: 'Switch to Sandbox',
		description: 'Toggle here to set up your test environment and start building.',
		ctaLabel: 'Got it',
		placement: 'bottom',
	},
	transaction: {
		selector: "[data-tour='transaction']",
		title: 'Make your first transaction',
		description: 'Head to your Wallet to fund, withdraw, or convert.',
		ctaLabel: 'Go to Wallet',
		ctaPath: '/wallet',
		nextStep: 'transactionWallet',
		placement: 'right',
		step: 1,
		steps: 2,
	},
	transactionWallet: {
		selector: "[data-tour='wallet-actions']",
		title: 'Fund, withdraw or convert',
		description: 'Start a transaction from here — it’ll then show up in the transactions table below.',
		ctaLabel: 'Got it',
		placement: 'bottom',
		step: 2,
		steps: 2,
	},
	mfa: {
		selector: "[data-tour='mfa']",
		title: 'Open Settings',
		description: 'Head to Settings to manage your account security.',
		ctaLabel: 'Go to Settings',
		ctaPath: '/settings',
		nextStep: 'mfaSecurity',
		placement: 'right',
		step: 1,
		steps: 3,
	},
	mfaSecurity: {
		selector: "[data-tour='settings-security']",
		title: 'Open Security',
		description: 'Select Security to manage 2FA and more.',
		ctaLabel: 'Open Security',
		ctaPath: '/settings/security',
		nextStep: 'mfaSetup',
		placement: 'bottom',
		step: 2,
		steps: 3,
	},
	mfaSetup: {
		selector: "[data-tour='security-mfa']",
		title: 'Enable MFA',
		description: 'Open MFA Authentication to set up an extra layer of security.',
		ctaLabel: 'Set it up',
		ctaPath: '/settings/security/mfa-factor-authentication',
		placement: 'bottom',
		step: 3,
		steps: 3,
	},
};

export const SPOTLIGHT_PADDING = 8;
export const COACHMARK_GAP = 16;
export const COACHMARK_WIDTH = 300;
export const VIEWPORT_MARGIN = 16;
